import {
  Component,
  input,
  OnDestroy,
  OnInit,
  output,
  signal,
} from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { IBannerSlide } from './contracts/interfaces/banner-slide.interface';
import { heroArrowLeftCircle, heroArrowRightCircle } from '@ng-icons/heroicons/outline';
@Component({
  selector: 'app-banner-slides',
  imports: [NgIcon],
  providers: [provideIcons({heroArrowLeftCircle, heroArrowRightCircle})],
  templateUrl: './banner-slides.component.html',
  styleUrl: './banner-slides.component.scss',
})
export class BannerSlidesComponent implements OnInit, OnDestroy {
  public currentSlideChange = output<number>();
  public linkOpenedChange = output<void>();

  public isModal = input(false);
  public hasGradient = input(true);
  public bannerSlidesInput = input<IBannerSlide[]>([]);
  public currentSlide = signal(0);
  public isLoading = signal(false);

  private readonly _timerSlide = 20000;
  private autoPlayTime?: ReturnType<typeof setInterval>;
  private lastSlideSort!: number;

  ngOnInit(): void {
    this.startAutoPlaySlides();    
  }

  ngOnDestroy(): void {
    if (this.autoPlayTime) {
      clearInterval(this.autoPlayTime);
    }
  }

  private startAutoPlaySlides(): void {
    if (!this.hasSlides()) return;

    this.autoPlayTime = setInterval(() => {
      const nextIndex = this.getRandomSlideIndex();
      this.currentSlide.set(nextIndex);
      this.currentSlideChange.emit(this.currentSlide())
    }, this._timerSlide);
  }

  private hasSlides(): boolean {
    return this.bannerSlidesInput().length > 0;
  }

  private getRandomSlideIndex(): number {
    const indexSlidesCont = this.bannerSlidesInput().length;
    let sort: number;

    do {
      sort = Math.floor(Math.random() * indexSlidesCont);
    } while (sort === this.lastSlideSort && indexSlidesCont > 1);

    this.lastSlideSort = sort;
    return sort;
  }

  private resetTimer(): void {
    clearInterval(this.autoPlayTime);
    this.startAutoPlaySlides();
  }

  public goToSlide(index: number): void {
    this.resetTimer();
    this.currentSlide.set(index);
    this.currentSlideChange.emit(this.currentSlide())
  }

  public prevSlide(): void {
    const lastSlide = this.bannerSlidesInput().length - 1;
    this.resetTimer();
    if (this.currentSlide() === 0) {
      this.goToSlide(lastSlide);
      return;
    }
    this.currentSlide.update(currentValue => currentValue - 1);
    this.currentSlideChange.emit(this.currentSlide())
  }

  public nextSlide(): void {
    const slides = this.bannerSlidesInput().length - 1;
    this.resetTimer();
    if (this.currentSlide() === slides) {
      this.currentSlide.set(0);
      this.currentSlideChange.emit(this.currentSlide())
      return;
    }
    this.currentSlide.update(currentValue => currentValue + 1);
    this.currentSlideChange.emit(this.currentSlide())
  }

  public openLink(url: string) {
    if (!url) return;

    this.linkOpenedChange.emit();
    window.open(url, '_blank')
  }
}
